<template>
  <div class="app-modal fly-talks-application-modal">
    <div class="fly-talks-application modal-content">
      <div class="fly-talks-application-title">
        <img class="arrow-left" src="@/assets/icons/arrow-white-alt.svg" @click="$emit('close')" />
        <h1>Prijava na Fly Talks</h1>
        <img class="close" src="@/assets/icons/close.svg" @click="$emit('close')" />
      </div>

      <div class="fly-talks-application-group">
        <h2>{{ flyTalk.name }}</h2>
        <p class="light-text">
          {{ getDayInCroatian(new Date(flyTalk.starts).getDay()) }}, {{ flyTalk.starts | filterDateTimeFromDate }} -
          {{ flyTalk.ends | filterTimeFromDate }}
        </p>
      </div>

      <div class="fly-talks-application-notice">
        <h3>Napomena</h3>
        <p class="light-text">
          Ispunjavanjem ovog upitnika pristajete na dijeljenje vaših podataka s predstavnicima tvrtki koji će vas
          intervjuirati. Imaju pravo zadržati te podatke kako bi stvorili širu sliku i bolji uvid u potencijalne
          zaposlenike. Molimo vas da dođete pet minuta ranije na zakazani fly talk.
        </p>
      </div>

      <div class="fly-talks-application-questions">
        <h2>Pitanja</h2>
        <form>
          <div class="form-field form-field--pointer">
            <img class="arrow-down" src="@/assets/icons/arrow-down-select.svg" alt="arrow-down" />
            <select
              id="birthyear"
              v-model="eventApplication.birthYear"
              v-bind:class="{ 'select-placeholder': !eventApplication.birthYear }"
            >
              <option v-bind:value="null">Godina rođenja*</option>
              <option v-for="year in getYears()" v-bind:value="year" v-bind:key="year">{{ year }}</option>
            </select>
            <label for="birthyear" v-if="eventApplication.birthYear" class="field">Godina rođenja*</label>
          </div>

          <div class="form-field">
            <input id="phone-number" type="text" v-model="eventApplication.phoneNumber" />
            <label for="phone-number" v-bind:class="eventApplication.phoneNumber && 'field-filled'">
              Broj mobitela*
            </label>
          </div>

          <div class="form-field fly-talks-application-checkbox">
            <h3>Stupanj obrazovanja*</h3>
            <label for="firstEducationRadioButton">
              <input
                type="radio"
                id="firstEducationRadioButton"
                value="0"
                v-model="eventApplication.levelOfEducation"
                name="educationRadioButton"
              />
              Osnovna škola
              <span class="checkmark" />
            </label>
            <label for="secondEducationRadioButton">
              <input
                type="radio"
                id="secondEducationRadioButton"
                value="1"
                v-model="eventApplication.levelOfEducation"
                name="educationRadioButton"
              />
              Srednja škola
              <span class="checkmark" />
            </label>
            <label for="thirdEducationRadioButton">
              <input
                type="radio"
                id="thirdEducationRadioButton"
                value="2"
                v-model="eventApplication.levelOfEducation"
                name="educationRadioButton"
              />
              Preddiplomski/stručni studij
              <span class="checkmark" />
            </label>
            <label for="fourthEducationRadioButton">
              <input
                type="radio"
                id="fourthEducationRadioButton"
                value="3"
                v-model="eventApplication.levelOfEducation"
                name="educationRadioButton"
              />
              Diplomski/specijalistički studij
              <span class="checkmark" />
            </label>
            <label for="fifthEducationRadioButton">
              <input
                type="radio"
                id="fifthEducationRadioButton"
                value="4"
                v-model="eventApplication.levelOfEducation"
                name="educationRadioButton"
              />
              Doktorat
              <span class="checkmark" />
            </label>
          </div>

          <div class="form-field fly-talks-application-checkbox">
            <h3>Radno iskustvo u godinama*</h3>
            <label for="firstExperienceRadioButton">
              <input
                type="radio"
                id="firstExperienceRadioButton"
                v-bind:value="0"
                v-model="eventApplication.workExperience"
                name="experienceRadioButton"
              />
              0
              <span class="checkmark" />
            </label>
            <label for="secondExperienceRadioButton">
              0 - 1
              <input
                type="radio"
                id="secondExperienceRadioButton"
                v-bind:value="1"
                v-model="eventApplication.workExperience"
                name="experienceRadioButton"
              />
              <span class="checkmark" />
            </label>
            <label for="thirdExperienceRadioButton">
              1 - 2
              <input
                type="radio"
                id="thirdExperienceRadioButton"
                v-bind:value="2"
                v-model="eventApplication.workExperience"
                name="experienceRadioButton"
              />
              <span class="checkmark" />
            </label>
            <label for="fourthExperienceRadioButton">
              2 - 5
              <input
                type="radio"
                id="fourthExperienceRadioButton"
                v-bind:value="3"
                v-model="eventApplication.workExperience"
                name="experienceRadioButton"
              />
              <span class="checkmark" />
            </label>
            <label for="fifthExperienceRadioButton">
              5+
              <input
                type="radio"
                id="fifthExperienceRadioButton"
                v-bind:value="4"
                v-model="eventApplication.workExperience"
                name="experienceRadioButton"
              />
              <span class="checkmark" />
            </label>
          </div>

          <div class="form-field fly-talks-application-textbox">
            <h3>Kakvu poziciju tražite?</h3>
            <textarea v-model="eventApplication.wantedPosition" />
          </div>

          <div class="fly-talks-application-files">
            <h3>Priloži CV</h3>
            <FileInput v-model="cvFile" v-on:added="fileAdded" v-on:removed="removedFile && removedFile" />
          </div>
        </form>
      </div>

      <div class="fly-talks-application-buttons">
        <button class="button" v-on:click="$emit('close')">Odustani</button>
        <button class="button" v-on:click="submit()" type="submit" value="submit">Spremi</button>
      </div>

      <div class="error" v-if="isPhoneNumberInvalid && isFormSubmitted">Broj mobitela nije validan.</div>
      <div class="error" v-if="isBirthYearInvalid && isFormSubmitted">Molimo unesite godinu rođenja.</div>
      <div class="error" v-if="isLevelOfEducationInvalid && isFormSubmitted">Molimo unesite završeno obrazovanje.</div>
      <div class="error" v-if="isWorkExperienceInvalid && isFormSubmitted">Molimo unesite radno iskustvo.</div>
      <div class="error" v-if="isWantedPositionInvalid && isFormSubmitted">Molimo opišite kakvu poziciju tražite.</div>
      <div class="error" v-if="isCvFileInvalid && isFormSubmitted">Molimo prikačite Vaš CV</div>
    </div>
  </div>
</template>

<script>
import FileInput from '../../../shared/FileInput';
export default {
  name: 'FlyTalkApplication',
  components: { FileInput },
  props: {
    flyTalk: Object,
  },
  data() {
    return {
      isFormSubmitted: false,
      eventApplication: {
        phoneNumber: '',
        birthYear: null,
        levelOfEducation: null,
        workExperience: null,
        wantedPosition: '',
        hobbiesAndActivities: '',
      },
      cvFile: null,
    };
  },
  computed: {
    isPhoneNumberInvalid() {
      return this.eventApplication.phoneNumber.length < 9 && !this.eventApplication.phoneNumber.match(/[0-9]+/g);
    },
    isBirthYearInvalid() {
      return this.eventApplication.birthYear == null;
    },
    isLevelOfEducationInvalid() {
      return this.eventApplication.levelOfEducation == null;
    },
    isWorkExperienceInvalid() {
      return this.eventApplication.workExperience == null;
    },
    isWantedPositionInvalid() {
      return !this.eventApplication.wantedPosition.length;
    },
    isCvFileInvalid() {
      return !this.cvFile;
    },
  },
  methods: {
    submit: function() {
      this.isFormSubmitted = true;
      if (this.isFormInvalid()) {
        return;
      }
      this.$emit('apply', this.eventApplication, this.cvFile);
    },
    isFormInvalid: function() {
      return (
        this.isPhoneNumberInvalid ||
        this.isBirthYearInvalid ||
        this.isLevelOfEducationInvalid ||
        this.isWorkExperienceInvalid ||
        this.isWantedPositionInvalid ||
        this.isCvFileInvalid
      );
    },
    getYears: function() {
      let currentYear = new Date().getFullYear();
      let years = [];
      let startYear = 1950;

      while (startYear <= currentYear) years.push(startYear++);

      return years.reverse();
    },
    fileAdded: function(file) {
      this.cvFile = file;
    },
    fileRemoved: function() {
      this.cvFile = null;
    },
    getDayInCroatian: function(dayIndex) {
      switch (dayIndex) {
        case 1:
          return 'Ponedjeljak';
        case 2:
          return 'Utorak';
        case 3:
          return 'Srijeda';
        case 4:
          return 'Četvrtak';
        case 5:
          return 'Petak';
        case 6:
          return 'Subota';
        case 7:
          return 'Nedjelja';
        default:
          return '';
      }
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/user/get-user-info`).then(({ data }) => {
      this.eventApplication.birthYear = data.birthYear;
    });
  },
};
</script>

<style scoped>
p,
h1,
h2,
h3 {
  margin: 0;
  padding: 0;
}

::-webkit-scrollbar {
  background: transparent;
}

.light-text {
  color: #ffffffcc;
}

.app-modal {
  align-items: flex-start !important;
}

.fly-talks-application {
  margin-top: 90px;
  margin-bottom: 40px;
  width: 33%;
  padding: 40px !important;
}

.fly-talks-application-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.fly-talks-application-title h1 {
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
}

.fly-talks-application-group {
  border-bottom: 1px solid #ffffff1a;
  line-height: 24px;
  padding-bottom: 16px;
  margin-bottom: 16px;
}

.fly-talks-application-group h2 {
  font-weight: 800;
  font-size: 16px;
}

.fly-talks-application-notice {
  margin-bottom: 48px;
}

.fly-talks-application-notice h3 {
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 4px;
}

.fly-talks-application-questions h2 {
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 25px;
}

input,
select {
  width: 100%;
  border: none;
  border-bottom: 1.5px solid #fff;
  color: #fff;
  font-size: 16px;
  padding: 10px 0;
  outline: none;
  background: transparent;
  transition: border-bottom 0.2s ease-in-out;
}

select {
  appearance: none;
}

select option {
  background: #0a181b;
}

input:focus,
select:focus {
  border-bottom: 1.5px solid #5ec4bc;
}

.form-field {
  margin-bottom: 56px;
  position: relative;
}

.form-field:nth-child(2) {
  margin-bottom: 88px;
}

.form-field--pointer > select {
  cursor: pointer;
}

.arrow-down {
  pointer-events: none;
  position: absolute;
  bottom: 15px;
  right: 10px;
}

.select-placeholder {
  font-size: 16px;
  color: #ffffffcc;
}

.form-field > label {
  position: absolute;
  color: #ffffffcc;
  font-size: 16px;
  left: 0;
  top: 15px;
  transition: all 0.1s ease;
}

.form-field input:focus + label,
.form-field select + label,
.form-field > label.field-filled {
  font-size: 12px;
  top: -10px;
}

.fly-talks-application-checkbox {
  display: flex;
  flex-direction: column;
}

.fly-talks-application-checkbox h3 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
}

.fly-talks-application-checkbox input[type='radio'] {
  display: none;
}

.fly-talks-application-checkbox label {
  position: relative !important;
  padding: 11px 0;
  margin-top: 1px;
  border-bottom: 1px solid #ffffff1f;
  color: #ffffffcc;
}

.checkmark {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  box-sizing: border-box;
  right: 0;
}

.checkmark::after {
  content: '';
  display: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #30cec2;
  margin: 3px;
}

.fly-talks-application-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.fly-talks-application-textbox h3,
.fly-talks-application-files h3 {
  margin-bottom: 16px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.fly-talks-application-textbox textarea {
  resize: none;
  width: 100%;
  height: 120px;
  padding: 5px;
  border-radius: 8px;
  background-color: transparent;
  color: #ffffffcc;
  box-sizing: border-box;
  outline: none;
}

.fly-talks-application-buttons {
  display: flex;
  justify-content: flex-end;
}

.button {
  font-size: 16px;
  font-weight: 800;
  padding: 12px 32px;
}

.button:first-of-type {
  color: #ffffff;
  background-color: transparent;
  border: 1px solid #ffffff;
  margin-right: 8px;
}

@media screen and (max-width: 1024px) {
  ::-webkit-scrollbar {
    display: none;
  }

  .fly-talks-application {
    margin-top: 0;
    margin-bottom: 0;
    width: 100%;
    padding: 40px !important;
    border-radius: 0 !important;
  }

  .fly-talks-application-title {
    justify-content: flex-start;
  }

  .fly-talks-application-buttons {
    flex-direction: column-reverse;
  }

  .button {
    width: 100%;
  }

  .button:nth-of-type(2) {
    margin-bottom: 16px;
  }

  .arrow-left {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin-right: 28px;
  }

  .close {
    display: none;
  }
}
</style>
